import HeaderImage from "../assets/images/talk.png";
import mainImage from "../assets/images/talkatives.png";
import LocationImage from "../assets/images/location.jpg";

import classes from "./Diavouleuseis.module.css";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useEffect, useState } from "react";
import { getConsultations, camelCaseText } from "../services/consultations";

const Diavouleuseis = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [consultationData, setConsultationData] = useState(null);

  const fetchConsultations = async () => {
    setIsLoading(true);
    const consultations = await getConsultations()
      .then((response) => {
        setIsLoading(false);
        if (response.error) {
          return [];
        } else {
          return response.data.consultations;
        }
      })
      .catch((error) => {
        console.error("Error fetching consultations:", error);
        setIsLoading(false);
        return error;
      });

    setConsultationData(consultations);

    console.log("TEST Consultations:", consultations);
  };

  useEffect(() => {
    fetchConsultations();
  }, []);

  const renderConsultations = () => {
    if (consultationData) {
      return consultationData?.map((data, id) => {
        return (
          <div
            key={`consultation_item_${id}`}
            className={`${classes.sectionContent} ${classes.sectionContentCard}`}
          >
            <div className={`${classes.consultationContainer}`}>
              <p className={`${classes.cardTitle}`}>
                {camelCaseText(data.title)}
              </p>

              <Link
                to={{
                  pathname: `/diavouleuseis/${data.consultation_id}`,
                  state: { userDetails: data },
                }}
                className={`${classes.contentButton} ${classes.cardButton}`}
              >
                Μάθετε Περισσότερα
              </Link>
            </div>
          </div>
        );
      });
    } else {
      return <p>Δεν υπάρχουν διαθέσημες διαβούλευσης!</p>;
    }
  };

  return (
    <div className={`${classes.container}`}>
      <div style={{ position: "relative" }}>
        <div className={`${classes.headerImageWrapper}`}>
          <img
            src={HeaderImage}
            alt="Diavouleuseis"
            className={`${classes.headerImage}`}
          />
        </div>
        <h3 className={`${classes.headerTitle}`}>Διαβουλεύσεις</h3>
      </div>
      <div className={`${classes.section}`}>
        <div className={`${classes.sectionContent}`}>
          <p className={`${classes.contentTitle}`}>Πληροφορίες για το έργο</p>
          <p className={`${classes.contentText}`}>
            Το έργο στοχεύει στην ορθολογική διαχείριση κρίσιμων τομέων παροχής
            υπηρεσιών από τον Δήμο Νικολάου Σκουφά στοχεύοντας την ενθάρρυνση
            των πολιτών να <b>εξετάσουν</b> προσεκτικά, να <b>ζητήσουν</b>, και
            να <b>αξιολογήσουν</b> εναλλακτικές πολιτικές, να <b>προτείνουν</b>{" "}
            πιο πρόσφορες λύσεις και να <b>αντιπαρατίθενται</b> με τεκμηριωμένα
            επιχειρήματα κατά τη διαδικασία λήψης αποφάσεων.
          </p>
          <Link
            to="/diavouleuseis/about"
            className={`${classes.contentButton}`}
          >
            Μάθετε Περισσότερα
          </Link>
        </div>

        <img
          className={classes.locationImage}
          src={mainImage}
          alt="dimos skoufa"
        />
      </div>
      <div className={`${classes.floater}`}>
        Η διαβούλευση μέσω αυτής της δικτυακής πλατφόρμας, αποτελεί μορφή
        ηλεκτρονικής, ισότιμης συμμετοχής σε έναν ευρύτερο δημόσιο διάλογο που
        λαμβάνει χώρα στο Δήμο Νικολάου Σκουφά.
      </div>

      <p className={`${classes.contentTitle}`}>Διαβουλεύσεις</p>

      <div className={`${classes.section} ${classes.consultationsSection}`}>
        {isLoading ? <p>Φόρτωση Δεδομένων</p> : renderConsultations()}
      </div>
    </div>
  );
};

export default Diavouleuseis;
